import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '../main.css';
export const createRegionDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createVmTemplateRegion',
        popover: {
          title: 'Select Region',
          description:
            'Choose the geographic region where this VM template will be deployed. The region you select can impact performance, latency, and compliance with local regulations.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateName',
        popover: {
          title: 'Template Name',
          description:
            'Provide a name for your VM template. This name helps you identify and organize your templates efficiently within the management console.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateDisk',
        popover: {
          title: 'Disk Configuration',
          description:
            'Set up the disk parameters for the VM template, including size and type. This configuration affects the storage capacity and performance of the virtual machines created from this template.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateOneTemplateId',
        popover: {
          title: 'Operating System',
          description:
            'Select the operating system for your VM template. The choice of OS determines the software environment and compatibility for the VMs based on this template.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateDescription',
        popover: {
          title: 'Template Description',
          description:
            'Add a description for the VM template. This information will help users understand the purpose and configuration details of the template, facilitating easier management and deployment.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
